import { BoxProps } from '@jfs/ui-new'
import { isMobile } from '../../utils'

const isLargeScreen = true

const styles = {
  topBar: {
    flexDirection: 'row',
    zIndex: 12,
    flexWrap: 'wrap',
    marginTop: 20,
    w: '100%',
    justifyContent: 'space-between',
  } as BoxProps,
  dateSelectorContainer: {
    flexDirection: 'row',
    marginTop: 20,
    flexWrap: 'wrap',
    maxWidth: '100%',
    justifyContent: 'flex-start',
  } as BoxProps,
  mobileSelectionFix: {
    marginRight: isMobile(isLargeScreen) ? 10 : 0,
    display: 'flex',
    borderWidth: 1,

    flexWrap: 'wrap',
    flexDirection: 'row',
    borderColor: 'TRANSPARENT',
  } as BoxProps,
  borderStyle: {
    height: 35,
    borderWidth: 1,
    borderColor: 'DISABLED_GREY',
    borderRadius: 4,
    paddingLeft: 8,
    paddingRight: 8,
    flexDirection: 'row',
    alignItems: 'center',
    width: '15vw',
  } as BoxProps,
  rowContainer: {
    flexDirection: 'row',
    marginTop: 20,
    minWidth: isMobile(isLargeScreen) ? '100%' : 10,
    maxWidth: '100%',
    alignItems: 'center',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
  } as BoxProps,
  generateContainer: {
    marginTop: isMobile(isLargeScreen) ? 24 : 0,
    minHeight: 36,
  } as BoxProps,
  createCampaignButton: {
    borderRadius: 4,
    ph: 16,
    pv: 8,
    backgroundColor: 'BLUE',
    underlayColor: 'BLUE',
    marginLeft: 10,
  } as BoxProps,
  tabsCenter: {
    backgroundColor: 'WHITE',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    paddingHorizontal: 8,
    borderColor: 'DISABLED_GREY',
    borderTopWidth: 1,
    borderLeftWidth: 1,
    borderBottomWidth: 1,
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: 4,
  } as BoxProps,
  refreshButton: {
    w: 80,
    backgroundColor: 'WHITE',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    paddingHorizontal: 8,
    paddingVertical: 5,
    borderColor: 'DISABLED_GREY',
    borderWidth: 1,
    borderTopRightRadius: 4,
    borderBottomRightRadius: 4,
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: 4,
  } as BoxProps,
}

export { styles }
